"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef } from "react";
export interface CommandEnvelope {
  operationId: string;
  /** The revision the user decided against; absent for creations. */
  revision?: number;
}

/**
 * One operation per intent. Retrying the same input against the same revision
 * after an unclear answer (a timeout, a 503) reuses the operation id, so the
 * server answers with the first attempt's outcome instead of acting twice. A
 * different input or revision is a new intent with a new id. Call `settle`
 * once the server has given a definite answer.
 */
export function useCommandAttempt() {
  const $ = _c(3);
  const attempt = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = (input, revision) => {
      const intent = JSON.stringify([input, revision]);
      if (attempt.current?.intent !== intent) {
        attempt.current = {
          intent,
          operationId: crypto.randomUUID()
        };
      }
      const {
        operationId
      } = attempt.current;
      return revision === null ? {
        operationId
      } : {
        operationId,
        revision
      };
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const prepare = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      attempt.current = null;
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const settle = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      prepare,
      settle
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}